module.exports = __webpack_public_path__ + "img/seeds.7f75a1ef.svg";